"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerClientProperties = void 0;
var views_settings_1 = require("../view-settings/views-settings");
var InnerClientProperties = (function () {
    function InnerClientProperties(viewsSettings) {
        this.showHiddenSymbols = false;
        this.showTableGridLines = false;
        this.viewsSettings = new views_settings_1.ViewSettings();
        this.viewsSettings.copyFrom(viewsSettings);
    }
    return InnerClientProperties;
}());
exports.InnerClientProperties = InnerClientProperties;
